export default function () {
  const dataToggle = document.querySelector('[data-toggle="toggle"]');

  if (dataToggle !== null) {
    dataToggle.addEventListener('click', function (event) {
      event.preventDefault();
      const $this = document.querySelector(this);

      $this.siblings('[data-toggle="toggle"]').trigger('toggle.placetel', [true]);
      $this.trigger('toggle.placetel', [$this.classList.contains('toggled')]);
    });

    dataToggle.addEventListener('click', function (event, close) {
      const $this = document.querySelector(this);
      const $target = document.querySelector($this.data('target'));

      if (close) {
        $this.classList.remove('toggled');
        $target.classList.remove('toggled');
      } else {
        $this.classList.add('toggled');
        $target.classList.add('toggled');
      }
    });
  }
}
